import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Container } from '@mui/material';

const Missing = () => {
    <Container maxWidth="sm" style={{ textAlign: 'center', padding: '200px 20px' }}>
        <Typography variant="h4" color="error" gutterBottom>
            صفحه یافت نشد
        </Typography>
        <Typography variant="body1" paragraph>
            صفحه‌ای که به دنبالش هستی یافت نشد
        </Typography>
        <Button 
            component={Link} 
            to="/" 
            variant="contained" 
            color="primary" 
            style={{ marginTop: '1rem' }}
        >
            برو به داشبورد
        </Button>
    </Container>
}

export default Missing